import * as React from "react";

function inferNativeButton(element: React.ReactElement): boolean | undefined {
  if (element.type === "button") {
    return true;
  }
  if (typeof element.type === "string") {
    return false;
  }
  const props = element.props as { to?: unknown; href?: unknown };
  if (props.to != null || props.href != null) {
    return false;
  }
  return undefined;
}

export function resolveAsChild({
  asChild,
  children,
  render,
  nativeButton,
}: {
  asChild?: boolean;
  children?: React.ReactNode;
  render?: unknown;
  nativeButton?: boolean;
}): {
  children?: React.ReactNode;
  render?: React.ReactElement;
  nativeButton?: boolean;
} {
  if (asChild && React.isValidElement(children)) {
    const inferred = inferNativeButton(children);
    const nextNativeButton = nativeButton ?? inferred;
    if (nextNativeButton === undefined) {
      return { render: children };
    }
    return {
      render: children,
      nativeButton: nextNativeButton,
    };
  }
  const nextRender = render as React.ReactElement | undefined;
  if (nativeButton === undefined) {
    return { children, render: nextRender };
  }
  return { children, render: nextRender, nativeButton };
}

export function asChildSlot(params: Parameters<typeof resolveAsChild>[0]): {
  children?: React.ReactNode;
  render?: React.ReactElement;
} {
  const { nativeButton: _nativeButton, ...slot } = resolveAsChild(params);
  return slot;
}
